import React from "react";
import "./Realestateconsulting.css";
import logoimage from "../../assets/cropped-cropped-cropped-عقاري-1-1 (1).webp";

const Realestateconsulting = () => {
  return (
   
    <div className="real-estate-container">
      <img
        src={logoimage}
        alt="Real Estate Consulting"
        className="hero-image"
      />
      <div className="content">
      <div className="content">
      <h1>خدمات الاستشارات العقارية</h1>
      <p>
        عقاري شركة استشارات عقارية رائدة في المملكة العربية السعودية، تُساعد مالكي العقارات والمطورين والمقيمين على تلبية احتياجاتهم العقارية. 
        نوفر أحدث استراتيجيات الاستثمار العقاري ومشاريع التطوير العقاري لتعزيز عائد الاستثمار.
      </p>
      
      <h2>رؤيتنا</h2>
      <p>
        تطمح لاند ستيرلينغ إلى توفير عقارات مستدامة للمالكين والمستثمرين في المملكة العربية السعودية. 
        نتولى كامل مراحل تطوير الاستراتيجية وتنفيذها لضمان نجاح مشاريعنا العقارية.
      </p>

      <h2>شركة استشارات استراتيجية احترافية</h2>
      <p>
        نحن شركة خاضعة لتنظيم الهيئة العامة للعقار (RERA)، وهدفنا هو مساعدة العملاء على تحقيق تطلعاتهم في الاستثمار والتطوير العقاري في وقت قياسي.
        مع أكثر من 13 عامًا من الخبرة في هذا المجال، نقدم استشارات استراتيجية تعود بالنفع على عملائنا.
      </p>
      
      <h2>أهمية خدمات الاستشارات الاستراتيجية</h2>
      <p>
        تتضمن خدمات الاستشارات الاستراتيجية إجراء أبحاث شاملة وفحصًا دقيقًا لاتخاذ قرارات عقارية مدروسة.
        تساعد مرحلة الفحص الدقيق في تطوير استراتيجية عقارية تعتمد على الوضع الحالي لمحفظة العميل العقارية وأهدافه المستقبلية.
      </p>
      <p>
        تساعد خدمات الاستشارات الاستراتيجية في تقليل المخاطر المرتبطة بالاستثمارات العقارية.
        حيث توفر هذه الخدمات معلومات حول استراتيجيات الاستثمار العقاري المناسبة، بالإضافة إلى خطة العمل التي يمكن اتباعها لتحقيق نتائج إيجابية.
      </p>

      <h2>خدماتنا في الاستشارات الاستراتيجية العقارية</h2>
      <ul>
        <li>التطوير</li>
        <li>أبحاث السوق وتوقعات الطلب</li>
        <li>تحليل أفضل استخدام</li>
        <li>دراسات الجدوى</li>
        <li>الفحص الدقيق</li>
        <li>تحليل السوق</li>
        <li>التقييم المالي</li>
        <li>خدمات مراقبة مخاطر الاستثمار</li>
        <li>استراتيجية التنفيذ</li>
        <li>التخطيط العام</li>
        <li>تحليل المقارنة</li>
        <li>استراتيجية الموقع</li>
        <li>استراتيجيات الدخول والخروج</li>
        <li>استشارات التأجير</li>
      </ul>

      <h2>خدمة عقود الاستشارات</h2>
      <p>هي اتفاقية بين الوسيط العقاري والطرف المستفيد من الاستشارة العقارية.</p>

      <h2>خطوات إنشاء عقد الاستشارة</h2>
      <ul>
        <li>تحديد نوع الطرف المتعاقد (منشأة/فرد).</li>
        <li>تحديد المالك المستفيد أو الممثل القانوني.</li>
        <li>التأكد من التمثيل القانوني (الوكالة) إذا كان الطرف المتعاقد ممثلًا قانونيًا.</li>
        <li>ملء البيانات المطلوبة بناءً على نوع العقد.</li>
        <li>تحديد مدة العقد.</li>
        <li>وضع آلية عمولة الوسيط.</li>
      </ul>
      </div>
    </div>
    </div>
  );
};

export default Realestateconsulting ;